import { Component } from "@builder.io/sdk";

export const officeLocationsConfig: Component = {
  name: "Office Locations",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "office-locations",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      helperText: "Tailwind CSS classes for the section",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      friendlyName: "Heading",
      defaultValue: "Office Locations",
      helperText: "Main heading for the office locations section",
      required: true,
    },
    {
      name: "items",
      friendlyName: "Office Locations",
      type: "list",
      helperText: "List of office locations",
      subFields: [
        {
          name: "image",
          type: "object",
          friendlyName: "Image",
          subFields: [
            {
              name: "src",
              type: "file",
              helperText: "Image file for the office location",
              required: true,
            },
            {
              name: "alt",
              type: "string",
              helperText: "Alt text for the image",
              required: true,
            },
          ],
        },
        {
          name: "title",
          type: "string",
          friendlyName: "Title",
          helperText: "Title for the office location",
          required: true,
        },
        {
          name: "description",
          type: "longText",
          friendlyName: "Description",
          helperText: "Description for the office location",
          required: true,
        },
        {
          name: "button",
          type: "object",
          friendlyName: "Button",
          subFields: [
            {
              name: "children",
              type: "string",
              friendlyName: "Button Text",
              helperText: "Text for the button",
              required: true,
            },
            {
              name: "href",
              type: "string",
              friendlyName: "Button Link",
              helperText: "Link for the button",
              required: true,
            },
          ],
          defaultValue: {
            children: "Learn More",
            href: "#",
          },
        },
      ],
      defaultValue: [
        {
          image: {
            src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fbd9214a869934eaca141140d9b7550db",
            alt: "Image of Menlo Park Office Location",
          },
          title: "Menlo Park",
          description:
            "Trusted caregiving for families in Menlo Park's thriving community.",
          button: {
            children: "Learn More",
            href: "/menlo-park",
          },
        },
        {
          image: {
            src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F75bf7bf2c63a4f0d8ce0c5760405ce18",
            alt: "Image of San Jose Office Location",
          },
          title: "San Jose",
          description:
            "Compassionate support designed for South Bay lifestyles.",
          button: {
            children: "Learn More",
            href: "/san-jose",
          },
        },
        {
          image: {
            src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F41f8dfb4649d49ad962aa98de868a1b7",
            alt: "Image of Campbell Office Location",
          },
          title: "Campbell",
          description: "Personalized home care for South Bay residents.",
          button: {
            children: "Learn More",
            href: "/campbell",
          },
        },
      ],
    },
  ],
};
